module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921014151_T.511e01d3.jpg";